export default "__VITE_ASSET__Ba5XO7Vw__"